var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseBgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12.7069L19.6464 20.3534L20.3535 19.6463L12.7071 11.9998L20.3535 4.35338L19.6464 3.64627L12 11.2927L4.35353 3.64627L3.64642 4.35338L11.2929 11.9998L3.64642 19.6463L4.35353 20.3534L12 12.7069Z",
    fill: "#272727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBgMenu);
export default __webpack_public_path__ + "static/media/closeBgMenu.a32a241a8a7e5451f8495fc53ec1de3d.svg";
export { ForwardRef as ReactComponent };